import { Button } from '@components/Button/Button'
import { useUnpaidPlanStatus } from '@hooks'
import { useScreen } from '@root/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCreditCard } from 'react-icons/fa'
import styled from 'styled-components'
import { motion } from 'framer-motion'

export const BillingLockBanner: React.FC = () => {
  const { t } = useTranslation()
  const { isMobile } = useScreen()
  const { startPaymentMethodSetup, isStartingPaymentMethodSetup } = useUnpaidPlanStatus()

  return (
    <StyledContainer data-page-banner="billing-lock">
      <StyledInfoContainer>
        <StyledIcon>
          <FaCreditCard />
        </StyledIcon>
        <StyledText>
          <StyledTitle>{t('billingLock.banner.title')}</StyledTitle>
          {!isMobile && (
            <StyledDescription>{t('billingLock.banner.description')}</StyledDescription>
          )}
        </StyledText>
      </StyledInfoContainer>

      <Button
        size="sm"
        intent="primary"
        type="button"
        showSpinner={isStartingPaymentMethodSetup}
        disabled={isStartingPaymentMethodSetup}
        onClick={() => void startPaymentMethodSetup()}
      >
        {t('billingLock.stripeUnpaid.updatePaymentButton')}
      </Button>
    </StyledContainer>
  )
}

const StyledContainer = styled(motion.div).attrs({
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.3 }
})`
  background: ${({ theme }) => theme.colors.warning}10;
  border: 1px solid ${({ theme }) => theme.colors.warning}40;
  padding: ${({ theme }) => theme.spacing.sm}rem ${({ theme }) => theme.spacing.sm}rem;
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

const StyledInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: ${({ theme }) => theme.colors.warning};
  border-radius: 50%;
  flex-shrink: 0;

  svg {
    color: white;
    width: 0.8rem;
    height: 0.8rem;
  }
`

const StyledText = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledTitle = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.warning};
`

const StyledDescription = styled.span`
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
`
